export default __webpack_public_path__ + "static/member2-419745d178bae9e61db96eedcb976c42.jpg";